'use client';

import { Dispatch, SetStateAction, useMemo } from 'react';
import { cn } from '@/helpers/common';
import IconKebab from '@/components/svgs/icons/kebab-icon';

import { ROUTES } from '@/constants/routes/default';
import { signOut } from 'next-auth/react';
import Dropdown from '../Dropdowns/Dropdown';

const HeaderDropdownDC = ({ session, isSighInPath }: { session: any; isSighInPath?: boolean }) => {
  const options = useMemo(() => {
    let result = [];

    if (session) {
      result = [
        { type: 'link', title: 'Find Jobs', href: ROUTES.jobs, withDivider: true },
        {
          type: 'link',
          title: 'Career Profile',
          href: ROUTES.profile,
          withDivider: false,
        },
        { type: 'link', title: 'About', href: ROUTES.about, withDivider: false },
        { type: 'link', title: 'Partners', href: ROUTES.partners, withDivider: false },
        {
          type: 'button',
          title: 'Sign Out',
          onClick: () => signOut(),
          withDivider: true,
        },
      ];
    } else {
      result = [
        {
          type: 'link',
          title: 'Find Jobs',
          href: ROUTES.jobs,
          withDivider: !!session,
        },
        { type: 'link', title: 'About', href: ROUTES.about, withDivider: false },
        { type: 'link', title: 'Partners', href: ROUTES.partners, withDivider: false },
        {
          type: 'link',
          title: isSighInPath ? 'Sign Up' : 'Sign In',
          href: ROUTES[isSighInPath ? 'signup' : 'signin'],
          withDivider: false,
        },
      ];
    }

    return result;
  }, [session, isSighInPath]);

  return (
    <Dropdown
      rootCn={''}
      listCn={'max-w-50 right-0 bg-white py-2 custom-shadow-dc-2 rounded-lg'}
      elementCn={'text-sm h-9 px-4 flex items-center hover:bg-dc-mercury'}
      dividerCn={'border-dc-mercury'}
      listHeader={
        session && session?.user?.email ? (
          <div
            className={cn(
              'px-4 text-xs text-dc-dove-gray overflow-hidden truncate whitespace-nowrap text-ellipsis',
            )}
          >
            {session?.user?.email}
          </div>
        ) : null
      }
      options={options}
    >
      {({
        setIsOpen,
        isOpen,
        listId,
      }: {
        setIsOpen: Dispatch<SetStateAction<boolean>>;
        isOpen: boolean;
        listId: string;
      }) => (
        <button
          aria-label="Menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? listId : undefined}
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
          className={cn(
            'flex items-center justify-center relative p-2 [&>svg>path]:fill-dc-cod-gray! no-underline default-transition rounded-lg bg-white hover:bg-dc-gallery',
            isOpen && 'bg-dc-gallery',
          )}
        >
          <IconKebab
            aria-hidden="true"
            className="shrink-0 [&>rect]:fill-current [&>rect]:transition-all [&>rect]:duration-300"
          />
        </button>
      )}
    </Dropdown>
  );
};

export default HeaderDropdownDC;
